module.exports = __webpack_public_path__ + "static/media/friend.1265c8e1.svg";